import { isCreativeDestinationLink } from "@common/utils/creativeDestinationLink";

/** Blank is valid and means “use the selected event link”. */
export function creativeDestinationLinkError(
  link: string | undefined | null
): string | null {
  return isCreativeDestinationLink(link) ? null : "Enter a valid http(s) URL";
}
